import React, { FC } from 'react';

import block from 'propmods';

import { routes } from '../../lib/routes';
import Link from '../Link/Link';

import SettingsIcon from './settings.svg';

import './UserSettingsPopup.scss';

const b = block('UserSettingsPopup');

interface Props {
    padRight?: boolean;
}

const UserSettings: FC<Props> = ({ padRight }) => {
    return (
        <Link to={routes.app.settings()} {...b('settings-button', { 'pad-right': padRight })}>
            <SettingsIcon />
        </Link>
    );
};

export default UserSettings;
